// Components==============
import { useRedux } from 'hooks/useRedux';
import { useToken } from 'hooks/useToken';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { useHistory } from 'react-router';
import { getSmartImage } from 'utilities/getSmartImage';
import Avatar from '../Avatar/Avatar';
import UnreadCount from '../Communication/UnreadCount/UnreadCount';
import './Notification.module.scss';
// =========================

export default function Notification({
  activity,
}: {
  activity: NotificationEntity;
}) {
  const translate = useTranslate();
  const history = useHistory();

  const projectId = activity.project_id
    ? activity.project_id
    : activity.target
    ? 'project_id' in activity.target
      ? activity.target.project_id
      : activity.target.id
    : undefined;

  const process =
    activity.target && 'project_id' in activity.target
      ? activity.target
      : undefined;

  const user = activity.author;
  const channelTarget = activity.target_type;

  function handleClick() {
    history.push(
      `/werkplaats/project-details/${projectId}/${
        activity.target_type === 'App\\User'
          ? activity.author.id
          : activity.target_id
      }`
    );
  }

  const projectThemeId = useRedux((state) =>
    projectId ? state.project?.entities.byId[projectId] : undefined
  )?.theme_id;

  const theme = useRedux((state) =>
    projectThemeId ? state.theme?.entities.byId[projectThemeId] : undefined
  );

  const token = useToken(process as ProcessEntity);

  const firstThemeImage = theme?.attachments
    .filter((a) => a.attachment_type === 'image')
    .map((a) => JSON.parse(a.attachment_data).file_path)[0] as string;

  return (
    <div
      styleName="notification"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div styleName="image">
        {!!user && channelTarget === 'App\\User' && (
          <Avatar user={user} size="medium" />
        )}
        {(channelTarget === 'App\\Project' ||
          channelTarget === 'App\\ProjectProcess') && (
          <img alt="notification" src={getSmartImage(firstThemeImage)} />
        )}
        {!!activity?.count && (
          <div styleName="unread">
            <UnreadCount count={activity?.count} />
          </div>
        )}
      </div>
      <div styleName="right">
        {channelTarget === 'App\\User' ? (
          <h3>
            {user?.first_name} {user?.last_name}
          </h3>
        ) : (
          <h3 style={{ fontWeight: 400 }}>
            {`${theme?.name}`}:{' '}
            <span style={{ fontWeight: 600 }}>
              {(token && 'name' in token ? token?.name : token?.title) ||
                translate('general.terms.group')}
            </span>
          </h3>
        )}
        <div styleName="description">
          {activity.target_type === 'App\\User' ? (
            <p>{activity.message_data}</p>
          ) : (
            <p>
              <b>
                {activity.author.first_name} {activity.author.last_name}
              </b>
              : {activity.message_data}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
